'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';

class OTAStore {
  @observable version = [];
  @observable targetVersion = [];
  @observable currentVersion = [];
  @observable tableArr = [];
  @observable selectedTableArr = [];
  @observable hasBeenUpdatedArr = [];
  @observable pagesize = 10;
  @observable page_num = 1;

  @observable selectedRowKeys = [];

  @action.bound
  changepagesize(e) {
    this.pagesize = parseInt(Math.abs(e.target.value)) || 1;
  }

  @action.bound
  changePage(page) {
    this.page_num = page;
  }

  @action
  loadOtaVersion() {
    fetch(`/api/ota/all`, { method: 'GET' }, json => {
      this.version = [...json] || [];
    });
  }
  @action
  getTargetOta() {
    fetch(`/api/ota/target`, { method: 'GET' }, json => {
      this.targetVersion = [...json] || [];
    });
  }
  @action
  getCurrentOta() {
    fetch(`/api/ota/current`, { method: 'GET' }, json => {
      this.currentVersion = [...json] || [];
    });
  }
  @action
  searchOta(deviceId, current, target) {
    let urlPara = buildUrl({
      page_size: 100000,
      page_num: 1,
      device_id: deviceId,
      ota_current: current,
      ota_target: target
    });
    fetch(`/api/ota/device${urlPara}`, { method: 'GET' }, json => {
      this.tableArr = [...json.content] || [];
    });
  }
  @action
  updateOta(data) {
    return fetch(
      '/api/ota/device',
      {
        method: 'POST',
        body: data
      },
      json => json
    );
  }
}
export default new OTAStore();



// WEBPACK FOOTER //
// ./src/store/OTA/OTA.js